(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_' 

    customElements.define('product-form', class extends Core {

        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        }

        render() {
            if (!this.$formTargeter) return; 
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
        }

        _submitHandler(e) {
            e.preventDefault();
            this.$toCartButton.addToCart(this.cartItems, this.mainVariantId);
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
        }
        
        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([ inputName, value ]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';
            return {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : '',
                properties: this._getProperties(inputName)
            }
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }
        _getProperties(inputName) {
            return inputName === 'id' ? this.properties : {};
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
        get properties() {
            const propertyKeys = this.formData.getAll('customPropertyReference');
            return propertyKeys.reduce((acc, key) => {
                acc[key] = this.formData.get(`properties[${key}]`);
                return acc;
            }, {})
        }
    })


   /* ITG: helper to check qty threshold and show popup */
   var itgPopupShown = false;
   function itgCheckQtyThreshold(qtyVal) {
     if (itgPopupShown) return;
     var popup = document.getElementById('itg-qty-popup');
     if (!popup) return;
     var threshold = parseInt(popup.getAttribute('data-qty-threshold'), 10);
     if (!threshold || qtyVal < threshold) return;
     popup.style.display = 'flex';
     setTimeout(function() { popup.classList.add('itg-active'); }, 10);
     itgPopupShown = true;
   }

   document.addEventListener('click', function(e){
  	let el = e.target;

    if(el.classList.contains('product-page-controls-item') || el.closest('.product-page-controls-item')) {
      if(!el.classList.contains('product-page-controls-item')) {
      	el = el.closest('.product-page-controls-item');
      }
    e.preventDefault();
      let parentEl = el.closest('.product-page-controls');
      let qtyInputEl = parentEl.querySelector('.product-page-controls-input');
      let qty_val = qtyInputEl.value * 1;
      if(el.classList.contains('plus_btn')) {
        qty_val = qty_val + 1;
      } else {
         qty_val = qty_val - 1;
      }
      if(qty_val <= 1) {
        qty_val = 1;
      }
      qtyInputEl.value = qty_val;

      /* ITG: check threshold on +/- click */
      itgCheckQtyThreshold(qty_val);

    }
  });

  /* ITG: check threshold on manual qty input */
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('product-page-controls-input')) {
      var val = parseInt(e.target.value, 10);
      if (val > 0) itgCheckQtyThreshold(val);
    }
  });

  /* ITG: check threshold on qty dropdown change */
  document.addEventListener('change', function(e) {
    if (e.target.name === 'quantity' && e.target.tagName === 'SELECT') {
      var val = parseInt(e.target.value, 10);
      if (val > 0) itgCheckQtyThreshold(val);
    }
  });

  /* ITG: close popup on X click, "No Thanks" click, or overlay click */
  document.addEventListener('click', function(e) {
    var popup = document.getElementById('itg-qty-popup');
    if (!popup) return;
    var isClose = e.target.id === 'itg-qty-popup-close';
    var isDismiss = e.target.id === 'itg-qty-popup-dismiss';
    var isOverlay = e.target === popup;
    if (isClose || isDismiss || isOverlay) {
      popup.classList.remove('itg-active');
      setTimeout(function() { popup.style.display = 'none'; }, 300);
    }
  });

})();